import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CustomDatePicker } from '../../components/CustomDatePicker';
import { usePrevious } from '../../custom-hooks';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';
import { getUITA } from '../../utils/commonUtils';
import { EMPTY_INPUT_MASKS, getDateFormat, processInputValue } from '../../utils/dateUtils';

const useStyles = makeStyles({
  root: {
    '& [class*=MuiFormControl-root]': {
      minWidth: 150,
    },
  },

  dateIconSpaceRtl: {
    '& input': {
      textAlign: 'center',
    },
  },
});

const SSDateBox = ({
  label,
  actions,
  isRequired,
  value = '',
  error,
  className,
  inTable,
  inFieldGroup,
  isHiddenLabel,
  instanceId,
  entityName,
  fieldName,
  isEditor,
  disabled,
}) => {
  const classes = useStyles();
  const [newValue, setValue] = useState(value);
  const [inputValue, setInputValue] = useState('');
  const [hasInputValueChanged, setInputValueChanged] = useState(false);
  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const prevDateValue = usePrevious(value);

  const hiddenLabel = inTable || (inFieldGroup && isHiddenLabel);

  // update value in store when value is changed from Calender modal picker
  const handleCalenderValueChange = (date) => {
    if (moment.isMoment(date)) {
      actions.updateControlValue(date.startOf('day').toDate());
      setInputValueChanged(false);
      return;
    }
  };

  // update value in store when value is changed manually
  const submitInputValue = () => {
    const dateFormat = getDateFormat(newValue);
    const newInputDate = processInputValue(newValue, dateFormat);

    if (inputValue !== newInputDate && hasInputValueChanged) {
      actions.updateControlValue(inputValue);
    }
  };

  const handleInputChange = (newInputValue) => {
    if (newInputValue !== inputValue) {
      EMPTY_INPUT_MASKS.includes(newInputValue) ? setInputValue('') : setInputValue(newInputValue);
      setInputValueChanged(true);
    }
  };

  const handleNewInputValue = (value) => {
    const dateFormat = getDateFormat(value);
    const newInputDate = processInputValue(value, dateFormat);

    if (prevDateValue !== value || newInputDate !== inputValue) {
      setInputValue(newInputDate);
    }
  };

  // Update inner state when `value` is changed from outside.
  useEffect(() => {
    setValue(value);
    handleNewInputValue(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <span
      ui-ta={getUITA('FormCtrl', 'SSDateBox', entityName, fieldName)}
      className={isRtlLanguage ? classNames(classes.root, classes.dateIconSpaceRtl) : classes.root}
    >
      <CustomDatePicker
        id={instanceId}
        label={hiddenLabel ? '' : label}
        className={className}
        storeValue={newValue}
        onChangeHandler={handleCalenderValueChange}
        onBlurHandler={submitInputValue}
        isRequired={isRequired}
        error={error}
        isDisabled={isEditor || disabled}
        inputValue={inputValue}
        onInputChangeHandler={handleInputChange}
      />
    </span>
  );
};

export default SSDateBox;
